import Vue from 'vue';
import Vuex from 'vuex';
import gestureAlerts from './modules/gestureAlerts';
import analysisData from './modules/analysisData';
import analysisQueue from './modules/analysisQueue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    gestureAlerts,
    analysisData,
    analysisQueue,
  },
});
